import { DEFAULT_RADIUS } from '~/utils/searchRadius'

const cookieName = 'jaty-search-parameters'
const radii = [0, 10000, 20000, 50000, 75000, 100000, 150000, 200000]

function normalize (parameters) {
  const selectedCity = parameters && parameters.city
  const city = selectedCity && {
    place_id: selectedCity.place_id,
    description: selectedCity.description,
    main: selectedCity.main || (selectedCity.structured_formatting && selectedCity.structured_formatting.main_text)
  }
  const radius = parameters && parameters.radius
  if (!city || !['place_id', 'main', 'description'].every(key =>
    typeof city[key] === 'string' && city[key].trim().length > 0 && city[key].length <= 300
  ) || !['number', 'string'].includes(typeof radius) || radius === '' || !radii.includes(Number(radius))) {
    return null
  }
  return {
    city: { place_id: city.place_id, main: city.main, description: city.description },
    radius: Number(radius)
  }
}

function homePlaceId (user) {
  return (user.city && user.city.place_id) || null
}

export const state = () => ({
  searchParameters: {},
  userId: null,
})

export const mutations = {
  SET_SEARCH_PARAMETERS (state, searchParameters) {
    state.searchParameters = searchParameters
  },
  SET_USER_ID (state, userId) {
    state.userId = userId
  }
}

export const actions = {
  fetchSearchParameters ({ commit, state }) {
    const userId = String(this.$auth.user.id)
    if (state.userId !== userId || Object.keys(state.searchParameters).length === 0) {
      let saved
      try {
        saved = this.$cookiz.get(cookieName)
      } catch (_) {
        // Unavailable cookies must not prevent searching.
      }
      // Filters saved for another profile city may point to a city outside the
      // profile country, which the backend no longer searches in.
      const parameters = saved && saved.userId === userId && saved.homePlaceId === homePlaceId(this.$auth.user) &&
        normalize(saved.parameters)
      commit('SET_SEARCH_PARAMETERS', parameters || {
        city: this.$auth.user.city,
        radius: DEFAULT_RADIUS
      })
      commit('SET_USER_ID', userId)
    }
  },
  setSearchParameters ({ commit }, searchParameters) {
    const parameters = normalize(searchParameters)
    if (!parameters) return
    const userId = String(this.$auth.user.id)
    commit('SET_SEARCH_PARAMETERS', parameters)
    commit('SET_USER_ID', userId)
    try {
      this.$cookiz.set(cookieName, { userId, homePlaceId: homePlaceId(this.$auth.user), parameters }, {
        path: '/',
        maxAge: 365 * 24 * 60 * 60,
        sameSite: 'lax',
        secure: typeof window !== 'undefined' && window.location.protocol === 'https:'
      })
    } catch (_) {
      // Keep the selected filters for this session when storage is blocked.
    }
  }
}
